import { render, staticRenderFns } from "./Musicians.vue?vue&type=template&id=55e6c0a4&scoped=true&"
import script from "./Musicians.vue?vue&type=script&lang=js&"
export * from "./Musicians.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6c0a4",
  null
  
)

export default component.exports